/**
 * Zuletzt angesehen.
 *
 * Eine kurze Liste in der Schiene: die Orte, zu denen zuletzt die Auskunft
 * offen war. Sie steht bewusst nicht im Konto - was man vorhin angetippt hat,
 * gehört in dieses Fenster, nicht auf einen Server. Deshalb liegt sie im
 * Browser und wandert nicht mit dem Profil.
 */
const SPEICHER = 'kgva.zuletzt';
const MAX = 6;

/** Derselbe Ort? Zehn Meter Unterschied sind noch derselbe Punkt. */
const gleich = (a, b) => Math.abs(a.lat - b.lat) < 1e-4 && Math.abs(a.lng - b.lng) < 1e-4;

export function createRecents({ host, onPick }) {
  let items = lesen();

  function lesen() {
    try {
      const roh = JSON.parse(localStorage.getItem(SPEICHER));
      return Array.isArray(roh) ? roh.filter((o) => o?.name && Number.isFinite(o.lat)) : [];
    } catch {
      return [];
    }
  }

  function schreiben() {
    try {
      localStorage.setItem(SPEICHER, JSON.stringify(items));
    } catch {
      /* Privater Modus: die Liste gilt dann nur für diese Sitzung */
    }
  }

  function merken(ort) {
    if (!ort?.name || !Number.isFinite(ort.lat) || !Number.isFinite(ort.lng)) return;
    const eintrag = {
      name: ort.name,
      lat: ort.lat,
      lng: ort.lng,
      klasse: ort.klasse || '',
      art: ort.art || ''
    };
    items = [eintrag, ...items.filter((o) => !gleich(o, eintrag))].slice(0, MAX);
    schreiben();
    render();
  }

  function render() {
    if (!host) return;
    host.textContent = '';
    if (!items.length) {
      const leer = document.createElement('p');
      leer.className = 'rail__leer';
      leer.textContent = 'Noch nichts angesehen.';
      host.append(leer);
      return;
    }
    for (const o of items) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'recent';
      b.title = o.art || o.klasse ? `${o.name} · ${o.art || o.klasse}` : o.name;
      const punkt = document.createElement('span');
      punkt.className = 'recent__dot';
      const name = document.createElement('span');
      name.className = 'recent__name';
      name.textContent = o.name;
      b.append(punkt, name);
      b.addEventListener('click', () => onPick?.(o));
      host.append(b);
    }
  }

  render();
  return { merken, render };
}
